import { useState, useCallback } from "react";

export function formatNumber(value, fallback = "—") {

  if (value === null || value === undefined || value === "") return fallback;

  const num = Number(value);
  if (isNaN(num)) return fallback;

  return new Intl.NumberFormat("en-US").format(num);
}

export function useFormattedNumber(initialValue = 0) {
  const [raw, setRaw] = useState(Number(initialValue));

  const set = useCallback((value) => {
    const num = Number(value);
    if (!isNaN(num)) setRaw(num);
  }, []);

  return {
    raw,
    formatted: formatNumber(raw),
    set,
  };
}
